import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../context/authProvider'
import { AuthRoutes } from './auth.routes'
import { UnauthRoutes } from './unauth.routes'

export function Router() {
  const navigate = useNavigate()
  const { validateToken, isLoggedIn, setIsLoggedIn } = useAuth()

  useEffect(() => {
    validateToken().then((validToken: boolean) => {
      console.log(validToken, isLoggedIn)
      if (!validToken && isLoggedIn) {
        localStorage.clear()
        setIsLoggedIn(false)
        navigate('/login')
      }
    })
  }, [navigator])

  return isLoggedIn ? <AuthRoutes /> : <UnauthRoutes />
}
